import React, { createContext, Dispatch, FunctionComponent, ReactNode, SetStateAction, useState } from 'react'

export const RecurringPaymentTabs = {
  Active: 'active',
  Inactive: 'inactive',
} as const

export type RecurringPaymentTabsProps = (typeof RecurringPaymentTabs)[keyof typeof RecurringPaymentTabs]

export interface RecurringPaymentsContextProps {
  tabValue: RecurringPaymentTabsProps
  setTabValue: Dispatch<SetStateAction<RecurringPaymentTabsProps>>
  selectedAgreementId: number
  setSelectedAgreementId: Dispatch<SetStateAction<number>>
}

export const RecurringPaymentsContextDefaults: RecurringPaymentsContextProps = {
  tabValue: RecurringPaymentTabs.Active,
  setTabValue: () => {
    console.log('in default setTabValue')
  },
  // @ts-ignore: OPERATION BLEED STOPPER
  selectedAgreementId: null,
  setSelectedAgreementId: () => {},
}

export const RecurringPaymentsContext = createContext<RecurringPaymentsContextProps>(RecurringPaymentsContextDefaults)

export interface RecurringPaymentsContextProviderProps {
  children: ReactNode
}
export const RecurringPaymentsContextProvider: FunctionComponent<RecurringPaymentsContextProviderProps> = ({ children }) => {
  const [tabValue, setTabValue] = useState<RecurringPaymentTabsProps>(RecurringPaymentTabs.Active)
  // @ts-ignore: OPERATION BLEED STOPPER
  const [selectedAgreementId, setSelectedAgreementId] = useState<number>(null)
  const value = {
    tabValue,
    setTabValue,
    selectedAgreementId,
    setSelectedAgreementId,
  }
  return <RecurringPaymentsContext.Provider value={value}>{children}</RecurringPaymentsContext.Provider>
}
